<template class="full-height">
  <div
    class="countries-latLng-components-app-container"
    style="position: relative; height: 100%; padding: 10px"
  >
    <el-dialog
      v-if="currentRow"
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="`${currentRow.label} 經緯度對應設定`"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <el-card class="box-card">
        <div>
          <el-form :inline="true" size="mini">
            <el-form-item>
              <el-button type="success" @click="addPosition">新增</el-button>
            </el-form-item>
          </el-form>

          <el-form v-for="(item, index) in positionList" :key="index" :inline="true" size="mini">
            <el-form-item label="" size="mini">
              <el-tag>{{ index + 1 }}</el-tag>
            </el-form-item>
            <el-form-item label="區域" size="mini">
              <el-select
                v-if="item.regions"
                v-model="item.region"
                value-key="key"
                placeholder="區域"
                size="mini"
                style="width: 100px"
                @change="selectedRegion(item)"
              >
                <el-option
                  v-for="(c, ind) in item.regions"
                  :key="ind"
                  :label="c.val"
                  :value="c.key"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="國家" size="mini">
              <el-select
                v-if="item.countries"
                v-model="item.country"
                v-loading="item.countriesLoading"
                filterable
                placeholder="國家"
                value-key="code"
                size="mini"
                style="width: 200px"
                @change="selectedCountry(item)"
              >
                <el-option
                  v-for="(c, ind) in item.countries"
                  :key="ind"
                  :label="c.chtName"
                  :value="c"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="城市" size="mini">
              <el-select
                v-if="item.cities"
                v-model="item.city"
                v-loading="item.countriesLoading || item.citiesLoading"
                clearable
                filterable
                placeholder="城市"
                value-key="code"
                size="mini"
                style="width: 200px"
                @change="selectedCity(item)"
              >
                <el-option
                  v-for="(c, ind) in item.cities"
                  :key="ind"
                  :label="c.chtName"
                  :value="c"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="經緯度(lng,lat)">
              <el-col class="line" :span="12">
                <el-input v-model="item.lng" placeholder="經度(lng)" />
              </el-col>
              <el-col class="line" :span="12">
                <el-input v-model="item.lat" placeholder="緯度(lat)" />
              </el-col>
            </el-form-item>

            <el-form-item>
              <el-button type="danger" @click="deletePosition(item)">刪除</el-button>
            </el-form-item>

            <el-form-item>
              <el-button size="mini" @click="googleMap(item)" icon="el-icon-position" type="success"
                >查看Google地圖</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePosition" size="mini">確 定</el-button>
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-if="currentRow"
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="`${currentRow.label} 貨幣設定`"
      :visible.sync="dialogCurrencyVisible"
      width="60%"
    >
      <el-card class="box-card">
        <div>
          <el-form :inline="true" size="mini">
            <el-form-item label="貨幣" size="mini">
              <el-select
                class="currency-select"
                multiple
                v-model="currentRow.currenciesCode"
                clearable
                filterable
                placeholder="貨幣"
                value-key="id"
                size="mini"
                style="width: 500px"
              >
                <el-option
                  v-for="(c, ind) in currencyOptionList"
                  :key="ind"
                  :label="`${c.currencyCode}-${c.currencyName}`"
                  :value="c.currencyCode"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveCurrencies" size="mini">確 定</el-button>
        <el-button @click="dialogCurrencyVisible = false" size="mini">取 消</el-button>
      </span>
    </el-dialog>

    <div style="position: relative; height: 80%">
      <div>
        <el-form :inline="true">
          <el-form-item>
            <el-button
              size="mini"
              style="cursor: pointer"
              :loading="listLoading"
              type="success"
              icon="el-icon-refresh-left"
              circle
              @click="refresh()"
            ></el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :row-style="rowStyle"
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        >

        <!-- <el-table-column
          align="center"
          label="區域代碼"
          width="150"
          prop="value"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.value }}</span>
          </template>
        </el-table-column> -->

        <el-table-column align="left" label="區域名稱" width="500" prop="label">
          <template slot-scope="scope">
            <span>{{ scope.row.label }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="經緯度設定" width="100">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="setPosition(scope.row)">設定</el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="貨幣設定" width="100">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="setCurrency(scope.row)">設定</el-button>
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="editData(scope.row)"
              >編輯</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'

import { getCountryRegions, getCountriesByRegion, getCitiesByCountryCode } from '@/api/travel'
import { getRegionArea, saveRegionAreaPosition, getCurrencies, saveCurrencies } from '@/api/system'

var defaultForm = {
  viewPointName: '',
  lat: 0,
  lng: 0,
}

export default {
  name: 'CountriesLatLng',
  props: {
    refreshTab1: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: () => null,
    },
  },
  watch: {
    refreshTab1: async function (newVal, oldVal) {
      let vm = this
      if (newVal) {
        await vm.refresh()
      }
    },
  },
  components: {
    Pagination,
  },
  data() {
    return {
      funcName: '區域管理',
      dialogCurrencyVisible: false,
      currentRow: null,
      positionList: [],
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-Sort',
      },
      total: 0,
      list: [],
      regionsSource: [],
      currencyOptionList: [],
    }
  },
  async created() {
    this.form = defaultForm
    await this.getCurrencies()
    await this.getCountryRegions()
    await this.getList()
  },
  methods: {
    async refresh() {
      await this.getList()
    },
    confirmCurrency(item) {
      console.log(this.currentRow)
    },
    async googleMap(row) {
      let lat = row.lat
      let lng = row.lng

      if (!lat || !lng) {
        alert('未輸入經緯度')
        return
      }
      let newWindow = window.open(`http://maps.google.com/?q=${lat},${lng}`)
      newWindow.opener = null
    },
    async getCurrencies() {
      let vm = this
      let resp = await getCurrencies()
      vm.currencyOptionList = resp.data
    },
    deletePosition(event) {
      if (!confirm(`確定要刪除此經緯度?`)) {
        return
      }
      const vm = this
      vm.positionList.splice(vm.positionList.indexOf(event), 1)
    },
    async addPosition() {
      const vm = this
      let emptyObj = {}

      const dataLen = vm.positionList.length
      if (dataLen > 0) {
        const copyObj = vm.positionList[dataLen - 1]
        emptyObj = JSON.parse(JSON.stringify(copyObj))
        emptyObj.id = null
        emptyObj.description = null
      } else {
        emptyObj = {
          regions: JSON.parse(JSON.stringify(vm.regionsSource)),
          countries: [],
          cities: [],
          lat: '',
          lng: '',
          citiesLoading: false,
          countriesLoading: false,
          passPointDialogVisible: false,
          description: '',
        }
      }

      vm.positionList.push(emptyObj)
    },
    async getCountryRegions() {
      const vm = this
      vm.regionsSource = []

      await getCountryRegions({}).then(response => {
        vm.regionsSource = response.data
      })
    },
    setCurrency(row) {
      let vm = this
      vm.currentRow = row
      vm.dialogCurrencyVisible = true
    },
    setPosition(row) {
      let vm = this
      if (row.position) {
        row.position.positionList.forEach(f => {
          f.regions = JSON.parse(JSON.stringify(vm.regionsSource))
        })

        vm.positionList = row.position.positionList
      } else {
        vm.positionList = []
      }
      vm.currentRow = row
      vm.dialogVisible = true
    },
    async selectedRegion(data) {
      const vm = this
      data.country = null
      data.city = null
      data.countries = []
      data.cities = []

      data.countriesLoading = true
      await getCountriesByRegion({ region: data.region }).then(response => {
        data.countriesLoading = false
        data.countries = response.data
      })
    },
    async selectedCountry(data) {
      const vm = this
      data.city = null
      data.cities = []
      data.citiesLoading = true
      data.lat = data.country.lat
      data.lng = data.country.lng
      await getCitiesByCountryCode({ countryCode: data.country.code }).then(response => {
        data.citiesLoading = false
        data.cities = response.data
      })
    },
    async selectedCity(data) {
      const vm = this
      data.lat = data.city.lat
      data.lng = data.city.lng
    },
    deletePlanning: function (event) {
      const vm = this
      vm.planningData.thisTime.data.splice(vm.planningData.thisTime.data.indexOf(event), 1)
    },

    rowStyle({ row, rowIndex }) {
      let style = {}
      if (row.value.indexOf('region') != -1) {
        style.color = 'blue'
      }
      if (row.value.indexOf('country') != -1) {
        style.color = 'red'
      }
      if (row.value.indexOf('city') != -1) {
        style.color = 'green'
      }
      return style
    },
    addData() {
      this.dialogVisible = true
    },
    editData(row) {
      this.form = row
      this.dialogVisible = true
    },
    async saveCurrencies() {
      let vm = this
      if (!confirm(`確定要儲存【${vm.currentRow.label}}】貨幣資料?`)) {
        return
      }

      if (!vm.currentRow) {
        alert(`請選擇國家或城市。`)
        return
      }

      let payload = {
        id: vm.currentRow.id,
        codes: vm.currentRow.currenciesCode,
      }

      if (vm.currentRow.currenciesCode.length == 0) {
        payload.codes = []
      }

      try {
        vm.dialogLoading = true
        let resp = await saveCurrencies(payload)
        vm.dialogCurrencyVisible = false
        await vm.getList()
        Message({
          message: '資料處理完成',
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        console.log(error)
      } finally {
        vm.dialogLoading = false
      }
    },
    async savePosition() {
      let vm = this
      if (!confirm(`確定要儲存【${vm.currentRow.label}}】經緯度資料?`)) {
        return
      }

      let validate = true
      let positions = []
      vm.positionList.forEach((f, index) => {
        if (!f.region) {
          alert(`第${index + 1}筆，未選擇區域。`)
          validate = false
        }

        if (!f.country) {
          alert(`第${index + 1}筆，未選擇國家。`)
          validate = false
        }

        if (!f.city) {
          alert(`第${index + 1}筆，未選擇城市。`)
          validate = false
        }

        positions.push({
          id: f.id,
          region: f.region,
          country: f.country,
          city: f.city,
          lat: f.lat,
          lng: f.lng,
        })
      })

      if (!validate) {
        return
      }

      let payload = {
        id: vm.currentRow.id,
        positionList: positions,
      }
      try {
        vm.dialogLoading = true
        let resp = await saveRegionAreaPosition(payload)
        vm.dialogVisible = false
        await vm.getList()
        Message({
          message: '資料處理完成',
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        console.log(error)
      } finally {
        vm.dialogLoading = false
      }
    },
    async getList() {
      this.listLoading = true
      try {
        let resp = await getRegionArea(this.listQuery)

        // resp.data.data.forEach((f) => {
        //   f.hasChildren = true;
        // });

        this.list = resp.data
        console.log(this.list)
        this.total = this.list.length
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
      }
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}

.currency-select .el-tag.el-tag--info {
  background-color: green !important;
  border-color: black !important;
  color: white !important;
  font-size: 17px !important;
  height: 30px !important;
}
</style>
